export const FONT = {
  FAMILY: ['MetricWeb', 'sans-serif'].join(','),
  COLOR: {
    PRIMARY: {
      MAIN: '#007B78',
      LIGHT: '#adefea'
    },
    SECONDARY: {
      MAIN: '#414248',
      CONTRAST_TEXT: '#ffffff',
      LIGHT: '#a8a9ad',
      INVERTED: {
        MAIN: '#ffffff',
        HOVER: '#10d0c3'
      }
    },
    TAB: {
      MAIN: '#414248',
      CONTRAST_TEXT: '#b0eee9',
    },
    TEXT: {
      MAIN: '#404040',
      DISABLED: '#A7AAAE'
    },
    CAPTION: {
      MAIN: '#878787',
    },
    ERROR: {
      DARK: '#b51225',
    },
    WARN: {
      LIGHT: '#FF6D6B'
    },
    DRAWER: {
      BACKGROUND: 'rgb(64, 67, 72)',
      FOOTER: '#2a2a2a',
      BORDER1: '#5c5c5c',
      BORDER2: '#4c4f56'
    }
  },
  WEIGHT: {
    BOLD: 700,
    LIGHT: 300,
    MEDIUM: 500,
    REGULAR: 400,
    SEMIBOLD: 600,
  },
};

export const BORDER = {
  COLOR: '#dcdddf'
};

export const BUTTON = {
  COLOR: {
    PRIMARY: {
      MAIN: '#10d0c3',
      HOVER: '#b0eee9',
      LIGHT: '#adefea'
    },
    SECONDARY: {
      HOVER: '#e7faf9',
      INVERTED: {
        MAIN: 'white',
        HOVER: '#10d0c3'
      }
    }
  }
};

export const TOGGLE_BUTTON = {
  COLOR: {
    PRIMARY: {
      MAIN: '#0c6460'
    },
  },
};

export const ANNOUNCEMENT= {
  HEIGHT: 52,
  COLOR: {
    INFO: '#00572c',
    WARNING: '#b30000',
  }
};

export const APPBAR = {
  HEIGHT: 60,
};

export const BREAKPOINT = {
  MAX_WIDTH_MOBILE: 600,
};

/**
 * The maximum content width.
 */
export const CONTENT_WIDTH = 1180;
/**
 * Horizontal left and right padding - 20px each
 */
export const CONTENT_PADDING_HORIZONTAL = 40;

export const GRAPH = {
  BAR: {
    COLOR: {
      PRIMARY: {
        ACTIVE: FONT.COLOR.PRIMARY.MAIN,
        INACTIVE: '#ff918f',
        HOVER: '#918fff'
      },
    },
  },
};

export const MARKET_GRAPH = {
  BAR: {
    COLOR: {
      PRIMARY: '#0c6460'
    }
  },
  AREA: {
    COLOR: {
      STROKE: '#10d0c3',
      STOP_PRICE: '#10d0c3',
      STOP_CAP: '#d4001a'
    }
  },
  DOT: {
    COLOR: {
      ACTIVE: '#0c6460'
    }
  }
};

export const MENU = {
  HEIGHT: {
    SOURCE: 392,
    SECTOR: {
      DEFAULT: 396,
      TOOLBAR: 506,
      COUNTRY_REGION: 542,
    },
  },
};

export const SEARCH_DRAWER_WIDTH = 270;

/**
 * Implement additional custom z-index values
 * to ensure it does not conflict with existing MUI z-indexes.
 * Refer to https://material-ui.com/customization/z-index/
 */
export const ZINDEX = {
  ANNOUNCEMENT: 1201,
  RIGHT_DRAWER: 1203,
  LEFT_DRAWER_POPPER: 1200,
};

export const TABCONTROL = {
  HOVER: '#ECEDF1',
  INDICATOR: {
    HOVER: BORDER.COLOR
  },
  APPBAR: {
    BORDER: '#ECEDF1'
  }
};